export default {
  credentialsModal: {
    kioskCode: "Código de dispositivo",
    password: "Contraseña",
    qrHelp:
      "Escanea este QR desde la pantalla de inicio de sesión de la tablet para autocompletar las credenciales.",
    securityWarningTitle: "Advertencia de seguridad:",
    securityWarningBody:
      "cualquiera que escanee este QR puede iniciar sesión hasta que regeneres la contraseña.",
  },
  posConfig: {
    title: "Vincular un lector",
    linkedReaderTitle: "Lector vinculado",
    readerId: "Id del lector del proveedor",
    refreshFromSumup: "Actualizar desde SumUp",
    disconnect: "Desvincular",
    replaceWithNewPairing: "Reemplazar por otro lector",
    searchSerialPlaceholder: "Buscar por número de serie…",
    showMockReaders: "Mostrar terminales mock",
    noAvailableReaders:
      "No hay lectores vinculables. Empareja un lector SumUp en Gestión de lectores primero.",
    selectReaderRequired:
      "Selecciona un lector disponible por número de serie.",
    linkReplace: "Vincular y reemplazar",
    linkReader: "Vincular lector",
    linkMockReader: "Vincular lector mock",
    unlinkConfirm:
      "¿Desvincular este lector de la tablet? El emparejamiento con SumUp se conserva; los pagos permanecerán desactivados hasta que vuelvas a vincular.",
  },
} as const;
